import { StringHelper } from './string.helperts';


export class ColorHelper {


  static invertColor(color: string) {
    // tslint:disable-next-line: one-variable-per-declaration
    let r: number | string;
    let g: number | string;
    let b: number | string;
    if (color.indexOf('rgb(') > -1) {
      let _c = color.slice(4);
      _c = _c.substr(0, _c.length - 1);
      const colors = _c.split(',');
      r = parseInt(colors[0].trim());
      g = parseInt(colors[1].trim());
      b = parseInt(colors[2].trim());
    }
    if (color.indexOf('rgba(') > -1) {
      let _c = color.slice(5);
      _c = _c.substr(0, _c.length - 1);
      const colors = _c.split(',');
      r = parseInt(colors[0].trim());
      g = parseInt(colors[1].trim());
      b = parseInt(colors[2].trim());

    }

    if (color.indexOf('#') === 0) {
      color = color.slice(1);
      // convert 3-digit hex to 6-digits.
      if (color.length === 3) {
        color = color[0] + color[0] + color[1] + color[1] + color[2] + color[2];
      }
      if (color.length !== 6) {
        throw new Error('Invalid HEX color.');
      }
      // invert color components
      r = (255 - parseInt(color.slice(0, 2), 16)).toString(16);
      g = (255 - parseInt(color.slice(2, 4), 16)).toString(16);
      b = (255 - parseInt(color.slice(4, 6), 16)).toString(16);
    }
    // pad each with zeros and return
    const res = '#' + StringHelper.padZero(r as string, 2) + StringHelper.padZero(g as string, 2) + StringHelper.padZero(b as string, 2);
    return res;
  }
}
